import React from 'react';

export interface SvgBackArrowProps {
  width?: string;
  height?: string;
  color?: string;
}

export const SvgBackArrow = ({
  width = '16',
  height = '14',
  color = "#5468FF",
}: SvgBackArrowProps) => (
  <svg
    width={width}
    height={height}
    viewBox={`0 0 16 14`}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M6.29289 0.292893C6.68342 -0.0976311 7.31658 -0.0976311 7.70711 0.292893C8.09763 0.683417 8.09763 1.31658 7.70711 1.70711L6.29289 0.292893ZM1 7L0.292893 7.70711C-0.0976315 7.31658 -0.0976315 6.68342 0.292893 6.29289L1 7ZM7.70711 12.2929C8.09763 12.6834 8.09763 13.3166 7.70711 13.7071C7.31658 14.0976 6.68342 14.0976 6.29289 13.7071L7.70711 12.2929ZM15 6C15.5523 6 16 6.44772 16 7C16 7.55228 15.5523 8 15 8V6ZM7.70711 1.70711L1.70711 7.70711L0.292893 6.29289L6.29289 0.292893L7.70711 1.70711ZM1.70711 6.29289L7.70711 12.2929L6.29289 13.7071L0.292893 7.70711L1.70711 6.29289ZM1 6H15V8H1V6Z"
      fill={color}
    />
  </svg>
);
